module.exports = __webpack_public_path__ + "img/02.b8aacd05.jpg";